import { appFeatures } from "../AppFeatures";
import { ILogger } from "./Logger";

export enum AsciiColor {
	reset = "\x1b[0m",
	red = "\x1b[31m",
	green = "\x1b[32m",
	yellow = "\x1b[33m",
	blue = "\x1b[34m",
	magenta = "\x1b[35m",
	cyan = "\x1b[36m",
	white = "\x1b[37m",
}

enum LogColors {
	Reset = AsciiColor.reset,
	Error = AsciiColor.red,
	Warning = AsciiColor.yellow,
	Info = AsciiColor.cyan,
	Debug = AsciiColor.green,
}

class UseColor {
	public static get Reset() {
		return appFeatures.isServer ? AsciiColor.reset : "";
	}
	public static get Error() {
		return appFeatures.isServer ? AsciiColor.red : "";
	}
	public static get Warning() {
		return appFeatures.isServer ? AsciiColor.yellow : "";
	}
	public static get Info() {
		return appFeatures.isServer ? AsciiColor.cyan : "";
	}
	public static get Debug() {
		return appFeatures.isServer ? AsciiColor.green : "";
	}
}

export default class LocalLogger implements ILogger {
	public async logJSError(error: Error): Promise<void> {
		console.error(UseColor.Error, this._getLogTime(), error, UseColor.Reset);
	}
	private _getLogTime() {
		return new Date().toLocaleTimeString("en-US", { hour12: false });
	}
	public async logCritical(...messages: any[]) {
		const stack3to6 = new Error().stack?.split("\n").slice(3, 6).join("\n");
		// const caller = new Error().stack?.split('\n')[3].trim();
		console.error(UseColor.Error, "!!!!!!!!", this._getLogTime(), ...messages, "!!!!!!!!", UseColor.Reset, stack3to6);
	}
	public async logError(...messages: any[]) {
		const stack3to6 = new Error().stack?.split("\n").slice(3, 6).join("\n");
		// const caller = new Error().stack?.split('\n')[3].trim();
		console.error(UseColor.Error, this._getLogTime(), ...messages, UseColor.Reset, stack3to6 ?? "");
	}
	public async logErrorNoStack(...messages: any[]) {
		console.error(UseColor.Error, this._getLogTime(), ...messages, UseColor.Reset);
	}
	public async logWarningNoStack(...messages: any[]) {
		console.warn(UseColor.Warning, this._getLogTime(), ...messages, UseColor.Reset);
	}

	public async logWarning(...messages: any[]) {
		const stack3to6 = new Error().stack?.split("\n").slice(3, 6).join("\n");
		// const caller = new Error().stack?.split('\n')[3].trim();
		console.warn(UseColor.Warning, this._getLogTime(), ...messages, UseColor.Reset, stack3to6);
	}

	public async logInfo(...messages: any[]) {
		console.log(UseColor.Info, this._getLogTime(), ...messages, UseColor.Reset);
	}

	public async logDebug(...messages: any[]) {
		console.log(UseColor.Debug, this._getLogTime(), ...messages, UseColor.Reset);
	}
}
